<template>
  <div>
    <div class="delivery-time" :class="{ 'is-loading': loading }">
      <icon-truck v-if="!loading" />

      <span
        v-if="!loading && immediateDelivery"
        class="delivery-time__text text-mobile-paragraph-s-bold text-desktop-paragraph-xs-bold"
        v-text="$string('product.immediate_delivery')"
      />

      <span
        v-if="!loading"
        class="delivery-time__text text-mobile-paragraph-s-regular text-desktop-paragraph-xs-regular"
        v-text="deliveryTimeText"
      />
    </div>
  </div>
</template>

<script>
/**
 * Vue: Delivery time (delivery-time)
 */
import IconTruck from '~icons/general/truck-order.svg';

export default {
  name: 'DeliveryTime',

  components: {
    IconTruck,
  },

  props: {
    isGiftCard: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    immediateDelivery() {
      return this.$variable('product.immediateDelivery')?.includes(
        this.$variable('product.deliveryTime'),
      );
    },

    deliveryTimeText() {
      if (this.isGiftCard) {
        return this.$string('product.delivery_time_giftcard');
      }
      return this.$string('product.delivery_time', {
        replace: { time: this.$variable('product.deliveryTime') },
      });
    },
  },
};
</script>

<style lang="scss">
@import './delivery-time';
</style>
